module.exports = __webpack_public_path__ + "static/media/caret-square-up.9e26495b.svg";